import React from 'react';
import { getPadding, getFontSize } from '../utils/cssVariableMapper';

const FormHeader = ({ config, content }) => {
  const titleClass = getFontSize(config?.titleSize || 'lg');
  const descClass = config?.descriptionSize === 'sm' ? 'text-sm' : 'text-base';
  const px = getPadding(config?.paddingX || 'lg', 'x');
  const py = getPadding(config?.paddingY || 'md', 'y');

  return (
    <div 
      className={`${px} ${py} border-b border-gray-100 transition-all`}
      style={{ 
          backgroundColor: config?.background || '#fff', 
          textAlign: config?.textAlign || 'left'
      }}
    >
      {content.showTitle && (
        <h2 
          className={`${titleClass} font-bold mb-2`}
          style={{ color: config?.titleColor || '#111827' }}
        >
          {content.title}
        </h2>
      )}
      {content.showDescription && (
        <p 
          className={`${descClass}`}
          style={{ 
              color: config?.textColor || '#4B5563',
              opacity: config?.descriptionOpacity || 0.8
          }}
        >
          {content.description}
        </p>
      )}
    </div>
  );
};

export default FormHeader;